import script from "./RegisterDoneModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterDoneModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterDoneModal.vue?vue&type=style&index=0&id=e3ad0594&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3ad0594"]])

export default __exports__